import { useAppContext } from '@Comments/context/AppContext';

import './Comment.scss';

type Props = {
  message: string;
};
export const EditorialMessage = ({ message }: Props) => {
  const { thread, env } = useAppContext();

  return (
    <>
      <li className="srf-comments-comment">
        <cite className="srf-comments-comment__user">
          <span className="h-offscreen">Kommentar von</span>
          <span>{thread.authorUsername}</span>
          <span
            className={`srf-comments-comment__logo srf-comments-comment__logo--${env.bu}`}></span>
        </cite>
        <blockquote className="srf-comments-comment__content">
          {message}
        </blockquote>
      </li>
    </>
  );
};
